import React, { FunctionComponent } from 'react';

interface ButtonBarProps {
  onClick: (e: React.MouseEvent) => void;
}

export const ButtonBar: FunctionComponent<ButtonBarProps> = ({ children, onClick }) => (
  <div className='buttonBar'>
    <button className='hideBtn' onClick={onClick}>
      Hide
    </button>
    {children}
  </div>
);
